import { useState } from "react";
import { Container, Row, Col, ListGroup, ListGroupItem } from "reactstrap";
import Accordion from "react-bootstrap/Accordion";

import "./index.scss";
import plus from "../../../../assets/images/+.png";

const AboutCareerPlusSection = () => {
  const [titles] = useState([
    {
      id: 1,
      title: "What Is Career Plus?",
    },
    {
      id: 2,
      title: "Engineering Camp",
    },
    {
      id: 3,
      title: "FMCG Camp",
    },
    {
      id: 4,
      title: "Finance&Audit Camp",
    },
    {
      id: 5,
      title: "Technology Camp",
    },
    {
      id: 6,
      title: "Why Career Plus?",
    },
  ]);
  const [isActive, setIsActive] = useState(1);

  const Desktop = () => {
    return (
      <section
        data-aos="fade-up"
        id="about-career-plus"
        className="about-career-plus position-relative"
      >
        <Container className="position-relative">
          <Row>
            <Col sm="12" md="12" lg="12">
              <h5 className="title">
                ABOUT <br></br> CAREER PLUS
              </h5>
            </Col>
          </Row>
          <Row className="about-career-plus-content d-flex align-items-start justify-content-end">
            <Col
              sm="12"
              md="8"
              lg="8"
              className={isActive === 1 ? "" : "display-none"}
              style={{ marginRight: "11px" }}
            >
              <div className="subtitle">
                <h5>WHAT IS CAREER PLUS?</h5>
              </div>

              <Row>
                <Col sm="12" md="12" lg="12">
                  <p className="text w-75">
                    Career Plus is a career camp event for Engineering, FMCG,
                    Finance&Audit and Technology sectors. 60 young talents,
                    which are 3rd, 4th year students, new graduates and master
                    students from various universities all over Turkey, are
                    selected from the applications, passing through the
                    evaluation processes with pre-evaluation, general aptitude
                    test, English proficiency exam and CV evaluation. We will
                    meet physically after 2 years in the 12th edition of the
                    sector-based Career Plus, which is held every year in
                    February-March.
                  </p>
                </Col>
              </Row>
            </Col>
            <Col
              sm="12"
              md="8"
              lg="8"
              className={isActive === 2 ? "" : "display-none"}
              style={{ marginRight: "11px" }}
            >
              <div className="subtitle">
                <h5>ENGINEERING CAMP</h5>
              </div>

              <Row>
                <Col sm="12" md="12" lg="12">
                  <p className="text w-75">
                    The engineering sector is one of the first sectors in terms
                    of importance for developing countries. At Career Plus
                    Engineering Camp, we aim to bring together the leading
                    companies of the engineering sector, which have working
                    areas in many different places from the durable consumer
                    sector to the automotive sector, with young talents.
                  </p>
                </Col>
              </Row>
            </Col>
            <Col
              sm="12"
              md="8"
              lg="8"
              className={isActive === 3 ? "" : "display-none"}
              style={{ marginRight: "11px" }}
            >
              <div className="subtitle">
                <h5>FMCG CAMP</h5>
              </div>

              <Row>
                <Col sm="12" md="12" lg="12">
                  <p className="text w-75">
                    Fast moving consumer goods (FMCG) sector is a dynamic,
                    constantly changing, and renewing sector, and naturally,
                    intense competition is experienced. FMCG sector is divided
                    into various categories such as food, beverage, chips,
                    cosmetics, cleaning products, tobacco etc. We bring together
                    the leading companies of the FMCG industry with dynamic
                    young talents, who can keep up with change, at the
                    <span style={{ whiteSpace: "nowrap" }}> Career Plus </span>
                    FMCG Camp.
                  </p>
                </Col>
              </Row>
            </Col>
            <Col
              sm="12"
              md="8"
              lg="8"
              className={isActive === 4 ? "" : "display-none"}
              style={{ marginRight: "11px" }}
            >
              <div className="subtitle">
                <h5>FINANCE&AUDIT CAMP</h5>
              </div>

              <Row>
                <Col sm="12" md="12" lg="12">
                  <p className="text w-75">
                    In the finance and audit sector, activities are carried out
                    in many areas such as the provision of resources and their
                    distribution, auditing the reflection of the financial
                    status and results of enterprises or institutions in
                    accordance with the legislation. At the Career Plus Finance
                    & Audit Camp, we bring together the major companies of the
                    finance and audit industry, which has been growing rapidly
                    in the world and in our country in recent years, with young
                    talents.
                  </p>
                </Col>
              </Row>
            </Col>
            <Col
              sm="12"
              md="8"
              lg="8"
              className={isActive === 5 ? "" : "display-none"}
              style={{ marginRight: "11px" }}
            >
              <div className="subtitle">
                <h5>TECHNOLOGY CAMP</h5>
              </div>

              <Row>
                <Col sm="12" md="12" lg="12">
                  <p className="text w-75">
                    The information and technology sector has gained more
                    importance in recent years with the worldwide pandemic. In
                    the globalizing world, all companies have started to invest
                    more in their work in the field of IT. We aim to bring
                    together the companies that lead these developments and open
                    new horizons in your career.
                  </p>
                </Col>
              </Row>
            </Col>
            <Col
              sm="12"
              md="8"
              lg="8"
              className={isActive === 6 ? "" : "display-none"}
              style={{ marginRight: "11px" }}
            >
              <div className="subtitle">
                <h5>WHY CAREER PLUS?</h5>
              </div>

              <Row>
                <Col sm="12" md="6" lg="6">
                  <h6 className="subsubtitle">For students</h6>
                  <p className="text">
                    + Meeting with the leading companies <br />+ Opportunity to
                    get to know the cultures of the companies closely <br />+
                    Networking with participants who are interested in the same
                    industry <br />+ Job or internship opportunity in leading
                    companies <br />+ Opportunity to experience the professional
                    business world through various case studies <br />+ Chance
                    to gain real job interview experience with interview
                    simulations <br />+ Surprise entertainments that will crown
                    their career journey and leave an unforgettable memory
                  </p>
                </Col>
                <Col sm="12" md="6" lg="6">
                  <h6 className="subsubtitle">For companies</h6>
                  <p className="text">
                    + Networking with candidates whose initial evaluation
                    processes have been completed for recruitment and internship
                    <br />+ Chance to reach the target audience directly
                    <br />
                    + Increasing brand awareness among young talents and to
                    explain the company culture at first hand
                    <br />+ Chance to share the employer brand with the right
                    target audience <br />+ Observing candidates’ perspectives
                    through case studies <br />+ Opportunity to get to know the
                    participants closely with interview simulations
                  </p>
                </Col>
              </Row>
            </Col>
            <Col sm="12" md="3">
              <ListGroup className="tab-item-list">
                {titles.map((t) => {
                  return (
                    <ListGroupItem
                      key={t.id}
                      className={
                        +isActive === t.id ? " isActive" : "" + "border-0 "
                      }
                      onClick={() => {
                        setIsActive(t.id);
                      }}
                    >
                      <span
                        className={t.id === isActive ? "" : "display-none"}
                        style={{ fontSize: "20px" }}
                      >
                        +
                      </span>
                      {t.title}
                    </ListGroupItem>
                  );
                })}
              </ListGroup>
            </Col>
            <img src={plus} alt="plus" className="plus-image" />
          </Row>
        </Container>
      </section>
    );
  };

  const [activeAccordion, setActiveAccordion] = useState(-1);

  const Mobile = () => {
    return (
      <section
        id="about-career-plus"
        className="about-career-plus-mobile-section"
      >
        <Container>
          <Row>
            <Col sm="12" md="12" lg="12">
              <h5 className="title">
                ABOUT <br></br> CAREER PLUS
              </h5>
            </Col>
          </Row>
          <Row>
            <Col>
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header
                    className={
                      activeAccordion === 0 ? "accordion-header-active" : ""
                    }
                    onClick={() => {
                      activeAccordion !== 0
                        ? setActiveAccordion(0)
                        : setActiveAccordion(-1);
                    }}
                  >
                    What Is Career Plus?
                  </Accordion.Header>
                  <Accordion.Body>
                    Career Plus is a career camp event for Engineering, FMCG,
                    Finance&Audit and Technology sectors. 60 young talents,
                    which are 3rd, 4th year students, new graduates and master
                    students from various universities all over Turkey, are
                    selected from the applications, passing through the
                    evaluation processes with pre-evaluation, general aptitude
                    test, English proficiency exam and CV evaluation. We will
                    meet physically after 2 years in the 12th edition of the
                    sector-based Career Plus, which is held every year in
                    February-March.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header
                    className={
                      activeAccordion === 1 ? "accordion-header-active" : ""
                    }
                    onClick={() => {
                      activeAccordion !== 1
                        ? setActiveAccordion(1)
                        : setActiveAccordion(-1);
                    }}
                  >
                    Engineering Camp
                  </Accordion.Header>
                  <Accordion.Body>
                    The engineering sector is one of the first sectors in terms
                    of importance for developing countries. At Career Plus
                    Engineering Camp, we aim to bring together the leading
                    companies of the engineering sector, which have working
                    areas in many different places from the durable consumer
                    sector to the automotive sector, with young talents.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header
                    className={
                      activeAccordion === 2 ? "accordion-header-active" : ""
                    }
                    onClick={() => {
                      activeAccordion !== 2
                        ? setActiveAccordion(2)
                        : setActiveAccordion(-1);
                    }}
                  >
                    FMCG Camp
                  </Accordion.Header>
                  <Accordion.Body>
                    Fast moving consumer goods (FMCG) sector is a dynamic,
                    constantly changing, and renewing sector, and naturally,
                    intense competition is experienced. FMCG sector is divided
                    into various categories such as food, beverage, chips,
                    cosmetics, cleaning products, tobacco etc. We bring together
                    the leading companies of the FMCG industry with dynamic
                    young talents, who can keep up with change, at the Career
                    Plus FMCG Camp.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header
                    className={
                      activeAccordion === 3 ? "accordion-header-active" : ""
                    }
                    onClick={() => {
                      activeAccordion !== 3
                        ? setActiveAccordion(3)
                        : setActiveAccordion(-1);
                    }}
                  >
                    Finance&Audit Camp
                  </Accordion.Header>
                  <Accordion.Body>
                    In the finance and audit sector, activities are carried out
                    in many areas such as the provision of resources and their
                    distribution, auditing the reflection of the financial
                    status and results of enterprises or institutions in
                    accordance with the legislation. At the Career Plus Finance
                    & Audit Camp, we bring together the major companies of the
                    finance and audit industry, which has been growing rapidly
                    in the world and in our country in recent years, with young
                    talents.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header
                    className={
                      activeAccordion === 4 ? "accordion-header-active" : ""
                    }
                    onClick={() => {
                      activeAccordion !== 4
                        ? setActiveAccordion(4)
                        : setActiveAccordion(-1);
                    }}
                  >
                    Technology Camp
                  </Accordion.Header>
                  <Accordion.Body>
                    The information and technology sector has gained more
                    importance in recent years with the worldwide pandemic. In
                    the globalizing world, all companies have started to invest
                    more in their work in the field of IT. We aim to bring
                    together the companies that lead these developments and open
                    new horizons in your career.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header
                    className={
                      activeAccordion === 5 ? "accordion-header-active" : ""
                    }
                    onClick={() => {
                      activeAccordion !== 5
                        ? setActiveAccordion(5)
                        : setActiveAccordion(-1);
                    }}
                  >
                    Why Career Pus?
                  </Accordion.Header>
                  <Accordion.Body>
                    <Row>
                      <Col sm="12" md="6" lg="6" className="mb-3">
                        <h6 className="subsubtitle">For students</h6>
                        <p className="text">
                          + Meeting with the leading companies <br />+
                          Opportunity to get to know the cultures of the
                          companies closely <br />+ Networking with participants
                          who are interested in the same industry <br />+ Job or
                          internship opportunity in leading companies <br />+
                          Opportunity to experience the professional business
                          world through various case studies <br />+ Chance to
                          gain real job interview experience with interview
                          simulations <br />+ Surprise entertainments that will
                          crown their career journey and leave an unforgettable
                          memory
                        </p>
                      </Col>
                      <Col sm="12" md="6" lg="6">
                        <h6 className="subsubtitle">For companies</h6>
                        <p className="text">
                          + Networking with candidates whose initial evaluation
                          processes have been completed for recruitment and
                          internship
                          <br />+ Chance to reach the target audience directly
                          <br />
                          + Increasing brand awareness among young talents and
                          to explain the company culture at first hand
                          <br />+ Chance to share the employer brand with the
                          right target audience <br />+ Observing candidates’
                          perspectives through case studies <br />+ Opportunity
                          to get to know the participants closely with interview
                          simulations
                        </p>
                      </Col>
                    </Row>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>
    );
  };

  return <>{window.innerWidth < 991 ? Mobile() : Desktop()}</>;
};

export default AboutCareerPlusSection;
